import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialFormTemplateState: Dtos.FormTemplate & IRegistrationFormState = {
    id: null,
    name: null,
    description: null,
    rank: null,
    itemComponentTypeId: null,
    formTemplateCategoryId: null,
    auditOnSave: null,
    allowVersions: null,
    collectionId: null,
    collection: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false
}

export interface IFormTemplateReduxFormState {
    id: IFieldState<number>,
    name: IFieldState<string>,
    description: IFieldState<string>,
    rank: IFieldState<number>,
    itemComponentTypeId: IFieldState<number>,
    formTemplateCategoryId: IFieldState<number>,
    auditOnSave: IFieldState<boolean>,
    allowVersions: IFieldState<boolean>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>,
    collectionId: IFieldState<number>,
    collection: IFieldState<Dtos.Collection>,
}
